<template>
  <div class="history-detail">
    <vue-slick-popover
      v-if="isPopoverVisible"
      :popover-options="popoverOptions"
      @closePopover="closePopover"
    >
      <vue-slick-popover-content>

        <TaiXiuResult
          v-if="roundData.game === 1"
          :round-data="roundData"
          @closePopover="closePopover"
        />
        <XocDiaResult
          v-if="roundData.game === 2"
          :round-data="roundData"
          @closePopover="closePopover"
        />

        <BaccaratResult
          v-if="roundData.game === 6"
          :round-data="roundData"
          @closePopover="closePopover"
        />

      </vue-slick-popover-content>
    </vue-slick-popover>
  </div>
</template>

<script>
import BaccaratResult from '@components/common/history/baccarat-result.vue';
import TaiXiuResult from '@components/common/history/tai-xiu-result.vue';
import XocDiaResult from '@components/common/history/xoc-dia-result.vue';
export default {
  components: {
    TaiXiuResult,
    XocDiaResult,
    BaccaratResult,
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    roundData: {
      type: Object,
      default: () => ({
        name: { type: String, default: "" },
        value: { type: String, default: "" },
        round: { type: Number, default: 0 },
        score: { type: Object, default: () => ({})},
        createdDate: { type: String, default: "" },
      })
    },
    isPopoverVisible: { type: Boolean, default: false },
    popoverOptions: { type: Object, default: () => ({})},
  },
  methods: {
    closePopover() {
      // console.log('HistoryDetail - closePopover')
      this.$emit('closePopover');
    },
  }
}
</script>

<style>

</style>
